import { useCallback, useMemo } from 'react';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';

import { Link } from 'components/Link';
import { Text } from 'components/Text/Text';
import { colors } from 'theme';
import { LANGUAGES, LanguageLocale } from 'utils/constants';
import { createCookie } from 'utils/cookies';

const DisabledLink = styled(Text)`
  color: ${colors.lightContentGrey};
  opacity: 0.5;
  cursor: auto;
`;

type Props = {
  languageLocale: LanguageLocale;
  languageLocaleUrl: string | undefined;
};

export function LanguageLinksItem({
  languageLocale,
  languageLocaleUrl,
}: Props) {
  const select = useCallback(
    () => createCookie('_LOCALE_', languageLocale, 1825),
    [languageLocale]
  );

  const title = useMemo(() => {
    if (!languageLocaleUrl)
      return sprintf(
        getText('This page is currently not available in %(language)s'),
        { language: LANGUAGES[languageLocale] }
      );

    return '';
  }, [languageLocaleUrl, languageLocale]);

  const isSelected = languageLocale !== CURRENT_LOCALE;

  if (isSelected && languageLocaleUrl) {
    return (
      <Link
        key={languageLocale}
        href={languageLocaleUrl || ''}
        data-qa-id={`locale-link-${languageLocale}`}
        onClick={select}
      >
        {LANGUAGES[languageLocale]}
      </Link>
    );
  }

  return (
    <DisabledLink
      data-qa-id={`disabled-locale-link-${languageLocale}`}
      key={languageLocale}
      title={title}
    >
      {LANGUAGES[languageLocale]}
    </DisabledLink>
  );
}
